import { globalSet } from 'app/utils';

/**
 * Creates a deep clone of an object using what the browser has
 * available. For most browsers, Object.assign will be used, but
 * for Internet Explorer, JSON.parse/JSON.stringify is utilized.
 *
 * Benchmark of various deep clone methds.
 * http://jsben.ch/#/bWfk9
 *
 * @param {Object} obj
 * @returns {any}
 */
export function clone(obj) {
    return (Object.assign)
        ? Object.assign({}, obj)
        : JSON.parse(JSON.stringify(obj));
}

globalSet('Utils.clone', clone);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/utils/clone/clone.ts